import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackRouteChange } from "@/lib/analytics";
import { initEngagement, resetEngagement } from "@/lib/engagement";

/**
 * Mounts the measurement layer (BTQ-65). Renders nothing.
 *
 * Placed after <Routes> in the tree so that on any commit where a page and this
 * component update together, the page's <SEOHead> has already registered its
 * title by the time the page view is assembled — React runs child effects before
 * ancestor/later-sibling effects. Lazily-loaded routes mount in a later commit;
 * trackRouteChange handles that case by waiting for the title.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initAnalytics();
    initEngagement();
  }, []);

  useEffect(() => {
    trackRouteChange(`${pathname}${search}`);
    // Scroll thresholds and form-visibility are per-route, not per-page-load.
    resetEngagement();
  }, [pathname, search]);

  return null;
}
